const useRefererPartnerCookies = (productId: string) => {
  const SIX_HOURS_IN_SECONDS = 6 * 60 * 60;

  const refererPartnerUrl = useCookie<string | null>(
    `refererPartnerUrl-${productId}`,
    {
      maxAge: SIX_HOURS_IN_SECONDS,
      watch: true,
    },
  );
  const refererPartnerName = useCookie<string | null>(
    `refererPartnerName-${productId}`,
    {
      maxAge: SIX_HOURS_IN_SECONDS,
      watch: true,
    },
  );

  return {
    refererPartnerUrl,
    refererPartnerName,
  };
};

export const useRefererPartnerData = (productId: string) => {
  const refererPartnerUrlQuery = useRouteQuery<string | null>(
    "refererPartnerUrl",
  );
  const refererPartnerNameQuery = useRouteQuery<string | null>(
    "refererPartnerName",
  );

  const { refererPartnerName, refererPartnerUrl } =
    useRefererPartnerCookies(productId);

  onMounted(() => {
    if (refererPartnerUrlQuery.value) {
      refererPartnerUrl.value = refererPartnerUrlQuery.value;
      refererPartnerUrlQuery.value = null;
    }

    if (refererPartnerNameQuery.value) {
      refererPartnerName.value = refererPartnerNameQuery.value;
      refererPartnerNameQuery.value = null;
    }
  });

  const clearRefererData = () => {
    refererPartnerUrl.value = null;
    refererPartnerName.value = null;
  };

  return { refererPartnerUrl, refererPartnerName, clearRefererData };
};
